import styled from 'styled-components';

export const Screen = styled.div<{open:boolean}>`
    display: ${props=>props.open ? 'block' : 'none' }; 
    z-index: 11; 
    position: absolute;
    left: 0;
    top: 0;
    right: 0px; 
    bottom: 0px; 

    @media screen and (max-width:960px){
        top: 60px;
        height:calc(100vh - 60px);
        background: rgba(0, 0, 0, 0.2);
    }
`;

export const Container = styled.div`
    width:1200px;  
    margin:0 auto;
    position:relative;

    @media screen and (max-width:960px){
        width:auto;
        /* position:inherit; */
    }
`;

export const Wrapper = styled.div`
    display:flex;
    position:absolute;
    justify-content:space-between;
    top:76px;
    left:744px;
    width:456px;
    height:158px;
    background:${props=>props.theme.colors.white};
    padding:20px;
    z-index:101;
    border-radius: 4px;
    box-shadow: 0px 0px 10px rgba(79, 105, 132, 0.2);

    @media screen and (min-width:961px) and (max-width:1199px){
        right:20px;    
    }

    @media screen and (max-width:960px){
        width:100vw;
        height:178px;
        top:0;
        right:0;
        left:0;
        border-radius:0;
    }
    
`;

export const Polygon = styled.div`
    position:absolute;
    top:64px;
    z-index:11;
    right:100px;
    width: 0; 
    height: 0; 
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid ${props=>props.theme.colors.white};

    @media screen and (max-width:960px){
        top:0px;
        z-index:9;
    }
`;

export const Info = styled.div`
    display:flex;
    flex-direction:column;
`;

export const Row = styled.div`
    display:flex;

    span{
        margin-right:12px
    }
`;

export const Progress = styled.div`
    width:84px;
    height:84px;
    margin-top:10px;

    .complete{
        color:${props=>props.theme.colors.white};
        background:${props=>props.theme.colors.primary};
        border-radius:50px;
        width:84px;
        height:84px;
        margin:0 auto;
        padding:30px 10px;
        font-size:22px;
        font-weight:700;
        text-align:center;
        margin-bottom:28px;
    }

    @media screen and (max-width:960px){
        width:84px;
        margin-top:10px;
    }
`;

export const Title = styled.h2`
    font-weight:400;
    font-size:16px;
    color:${props=>props.theme.colors.secundary};
    margin-bottom:8px;
`;

export const Description = styled.p`
    font-weight:400;
    font-size:14px;
    /* width:311px; */
    color:#222;
    margin-bottom:12px;
    margin-right:21px;
`;

export const Icon = styled.div`
    width:14px;
    height:16px;
    margin-right:8px;
    color:${props=>props.theme.colors.primary};
`;

export const Text = styled.h2`
    font-size:14px;
    font-weight:bold;
`;